import { FC, MouseEventHandler, ReactNode } from 'react';
import { ChevronIcon } from '@/icons';
import { StyledBackLink } from './BackLinkStyles';

type TBackLinkProps = {
  to: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const BackLink: FC<TBackLinkProps> = ({ to, children, onClick }) => (
  <StyledBackLink to={to} onClick={onClick}>
    <ChevronIcon rotate={90} />
    {children}
  </StyledBackLink>
);

export default BackLink;
